export default "__VITE_ASSET__BBXRhsQ2__"